import {useQuery} from "@tanstack/react-query";
import {readInventoryAtIncoming} from "../../../../api/inventory/IncomingApi";
import {InvSearchParamType} from "../../../../pages/inventory/inv/list/interface";
import {invListMapInit} from "../../../../pages/inventory/inv/list/state";

type Props = {
    param: InvSearchParamType;
};

export const useReadInventoryAtIncoming = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readInventoryAtIncoming", param],
        queryFn: async () => await readInventoryAtIncoming(param),
        select: (res) => res?.data.result ?? invListMapInit,
    });

    return {data};
};
